import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {DEFAULT_PAGE_SIZE} from '../../shared/consts';
import {SiteFilter} from '../models/site-filter';
import {SelectedItem} from '../../order/models/order';
import {
  ChangeSitesPageSizeAction, ClearSelectedSitesAction, LoadSitesSuccessAction, OrderSitesByAction,
  PageSitesToAction,
  QuickSearchSitesAction,
  SearchSitesAction,
  siteListActionTypes,
  ToggleSearchSitesAction, ToggleSitesSelectionAction
} from '../actions/site-list';
import {Site} from '../../shared/models/site';


export interface SitesListState {
  showFilter: boolean;
  quickSearch: string;
  filter: SiteFilter | string | number;
  page: number;
  pageSize: number;
  orderBy: string;
  array: Site[];
  count: number;
  selectedSite: SelectedItem[];
}

const initialState: SitesListState = {
  showFilter: false,
  quickSearch: undefined,
  filter: undefined,
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  orderBy: 'displayName',
  array: [],
  count: 0,
  selectedSite: [],
};

export function SitesListReducer(state: SitesListState = initialState, action: Action): SitesListState {
  switch (action.type) {
    case siteListActionTypes.TOGGLE_SEARCH:
      return handleToggleSearchAction(state, action);
    case siteListActionTypes.QUICK_SEARCH:
      return handleQuickSearchAction(state, action);
    case siteListActionTypes.SEARCH:
      return handleSearchAction(state, action);
    case siteListActionTypes.PAGE_TO:
      return handlePageToAction(state, action);
    case siteListActionTypes.CHANGE_PAGE_SIZE:
      return handleChangePageSizeAction(state, action);
    case siteListActionTypes.ORDER_BY:
      return handleOrderByAction(state, action);
    case siteListActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case siteListActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case siteListActionTypes.SELECT_PAGE:
      return handleSelectPageAction(state);
    case siteListActionTypes.UNSELECT_PAGE:
      return handleUnselectPageAction(state);
    case siteListActionTypes.TOGGLE_SELECTION:
      return handleToggleSitesSelectionAction(state, action);
    case siteListActionTypes.CLEAR:
      return handleClearAction();
    case siteListActionTypes.CLEAR_SELECTED:
      return handleClearSelectedAction(state, action);
    default:
      return state;
  }
}

function handleClearAction(): SitesListState {
  return initialState;
}

function handleSelectPageAction(state: SitesListState): SitesListState {
  const newState: SitesListState = {
    showFilter: state.showFilter,
    filter: state.filter,
    quickSearch: state.quickSearch,
    page: state.page,
    pageSize: state.pageSize,
    orderBy: state.orderBy,
    array: state.array,
    count: state.count,
    selectedSite: _.remove(  _.map(state.array, sites => (
     sites.status !== 1 ? { uuid: sites.uuid , name: sites.name } : null
      ))
      // tslint:disable-next-line:typedef
    , function(n) {
      return n ? n : '';
    })
  };
  return newState;
}

function handleUnselectPageAction(state: SitesListState): SitesListState {
  const newState: SitesListState = {
    showFilter: state.showFilter,
    filter: state.filter,
    quickSearch: state.quickSearch,
    page: state.page,
    pageSize: state.pageSize,
    orderBy: state.orderBy,
    array: state.array,
    count: state.count,
    selectedSite: []
  };
  return newState;
}

function handleToggleSearchAction(state: SitesListState, action: ToggleSearchSitesAction): SitesListState {
  const newState: SitesListState = {
    showFilter: action.payload,
    quickSearch: state.quickSearch,
    filter: state.filter,
    page: state.page,
    pageSize: state.pageSize,
    orderBy: state.orderBy,
    array: state.array,
    count: state.count,
    selectedSite: []
  };
  return newState;
}

function handleQuickSearchAction(state: SitesListState, action: QuickSearchSitesAction): SitesListState {
  const newState: SitesListState = {
    showFilter: state.showFilter,
    quickSearch: action.payload,
    filter: state.filter,
    page: 1,
    pageSize: state.pageSize,
    orderBy: state.orderBy,
    array: state.array,
    count: state.count,
    selectedSite: []
  };
  return newState;
}

function handleSearchAction(state: SitesListState, action: SearchSitesAction): SitesListState {
  const newState: SitesListState = {
    showFilter: state.showFilter,
    quickSearch: state.quickSearch,
    filter: action.payload,
    page: 1,
    pageSize: state.pageSize,
    orderBy: state.orderBy,
    array: state.array,
    count: state.count,
    selectedSite: []
  };
  return newState;
}

function handlePageToAction(state: SitesListState, action: PageSitesToAction): SitesListState {
  const newState: SitesListState = {
    showFilter: state.showFilter,
    quickSearch: state.quickSearch,
    filter: state.filter,
    page: action.payload,
    pageSize: state.pageSize,
    orderBy: state.orderBy,
    array: state.array,
    count: state.count,
    selectedSite: []
  };
  return newState;
}

function handleChangePageSizeAction(state: SitesListState, action: ChangeSitesPageSizeAction): SitesListState {
  const newState: SitesListState = {
    showFilter: state.showFilter,
    quickSearch: state.quickSearch,
    filter: state.filter,
    page: 1,
    pageSize: action.payload,
    orderBy: state.orderBy,
    array: state.array,
    count: state.count,
    selectedSite: []
  };
  return newState;
}

function handleOrderByAction(state: SitesListState, action: OrderSitesByAction): SitesListState {
  const newState: SitesListState = {
    showFilter: state.showFilter,
    quickSearch: state.quickSearch,
    filter: state.filter,
    page: state.page,
    pageSize: state.pageSize,
    orderBy: action.payload,
    array: state.array,
    count: state.count,
    selectedSite: []
  };
  return newState;
}

function handleLoadSuccessAction(state: SitesListState, action: LoadSitesSuccessAction): SitesListState {
  const newState: SitesListState = {
    showFilter: state.showFilter,
    quickSearch: state.quickSearch,
    filter: state.filter,
    page: state.page,
    pageSize: state.pageSize,
    orderBy: state.orderBy,
    array: action.payload.array,
    count: action.payload.count,
    selectedSite: []
  };
  return newState;
}

function handleLoadErrorActions(state: SitesListState): SitesListState {
  return state;
}

function handleToggleSitesSelectionAction(state: SitesListState, action: ToggleSitesSelectionAction): SitesListState {
  const selectedIndex = _.findIndex(state.selectedSite, ['uuid', action.payload.uuid]);
  let selected: SelectedItem[];
  if (selectedIndex > -1) {
    selected = _.filter(state.selectedSite, sc => sc.uuid !== action.payload.uuid);
  } else {
    const site = _.find(state.array, u => u.uuid === action.payload.uuid);
    const selectedSite: SelectedItem = {uuid: site.uuid , name: site.name};
    selected = [...state.selectedSite, selectedSite];
  }

  const newState: SitesListState = {
    showFilter: state.showFilter,
    quickSearch: state.quickSearch,
    filter: state.filter,
    page: state.page,
    pageSize: state.pageSize,
    orderBy: state.orderBy,
    array: state.array,
    count: state.count,
    selectedSite: selected
  };
  return newState;
}

function handleClearSelectedAction(state: SitesListState, action: ClearSelectedSitesAction): SitesListState {
  const newState: SitesListState = {
    showFilter: state.showFilter,
    quickSearch: state.quickSearch,
    filter: state.filter,
    page: state.page,
    pageSize: state.pageSize,
    orderBy: state.orderBy,
    array: state.array,
    count: state.count,
    selectedSite: []
  };
  return newState;
}

export const sitesListSelectors = {
  showFilter: (state: SitesListState) => _.get(state, 'showFilter', false),
  quickSearch: (state: SitesListState) => _.get(state, 'quickSearch'),
  filter: (state: SitesListState) => _.get(state, 'filter'),
  page: (state: SitesListState) => _.get(state, 'page', 1),
  pageSize: (state: SitesListState) => _.get(state, 'pageSize', DEFAULT_PAGE_SIZE),
  orderBy: (state: SitesListState) => _.get(state, 'orderBy'),
  array: (state: SitesListState) => _.get(state, 'array', []),
  count: (state: SitesListState) => _.get(state, 'count', 0),
  selectedSite: (state: SitesListState) => _.get(state, 'selectedSite', []),
  selectSiteByUuid: (state: SitesListState, props: string) => {
    return state.array.find((site: Site) => site.uuid === props);
  }
};
